import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import NormalizeDoubleSlash from "./utils/Functions/NormalizeDoubleSlash";
import ErrorBoundary from "./components/ErrorBoundary";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
  });
}

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY in .env");
}

function ClerkWithRouter({ children }) {

  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
 >
      {children}
    </ClerkProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <BrowserRouter >
      <NormalizeDoubleSlash />

      <ClerkWithRouter>
        <App />
      </ClerkWithRouter>
    </BrowserRouter>
  </ErrorBoundary>
);